import { parseLocalStorage } from '@/functions/utility';

const state = {
  guest: null,
  username: '',

  enterAfterAuth: false,
  rejoinAfterAuth: false,

  guestStorageData: null,
  hideSuggestedGuestLogin: false,
};

const getters = {
  guest: (state) => state.guest || {},
  userId: (state, getters, rootState, rootGetters) => state.guest?.userId || rootGetters['current_user/id'] || '',
  authToken: (state) => state.guest?.oneTimeSignInToken || '',
  username: (state) => state.username,

  isEnteringAfterAuth: (state) => state.enterAfterAuth,
  isRejoiningAfterAuth: (state) => state.rejoinAfterAuth,

  guestStorageData: (state) => state.guestStorageData, //guest data from local storage
  hideSuggestedGuestLogin: (state) => state.hideSuggestedGuestLogin,
};

const mutations = {
  GUEST: (state, value) => state.guest = value,
  USER_ID: (state, value) => state.guest ? state.guest.userId = value : state.guest = {userId: value},
  USERNAME: (state, value) => state.username = value,

  ENTER_AFTER_AUTH: (state, value) => state.enterAfterAuth = value,
  REJOIN_AFTER_AUTH: (state, value) => state.rejoinAfterAuth = value,

  GUEST_STORAGE_DATA: (state, value) => state.guestStorageData = value,
  HIDE_SUGGESTED_GUEST_LOGIN: (state, value) => state.hideSuggestedGuestLogin = value, //if clicking switch
};

const actions = {
  async createGuestAccount({getters, rootGetters, commit, dispatch}, [username, locationId]) {
    if(!rootGetters['api/auth/authenticated'] && !getters.isEnteringAfterAuth) {
      let guestRes = await dispatch('handleCreateGuestLogin', locationId)
      let guest = guestRes?.success
      if(guest) {
        commit('GUEST', guest)
        localStorage.setItem('guestUser', JSON.stringify({...guest, username}))
        dispatch('current_user/setExternalGuest', true, {root: true})
        //one time login with sso - redirect to sso with redirectUrl
        await dispatch('api/auth/loginAsGuest', [getters.userId, getters.authToken], {root: true})
        return guestRes
      } else {
        dispatch('popups/guest/errorEnteringGuestLobby', null, {root: true})
        return guestRes
      }
    }
  },
  async existingGuestLoginFailed({getters, commit, dispatch}) {
    let guest = getters.guestStorageData
    if(!guest?.username || !guest.locationId) return //go to reset space/room lobby + clear existing guest
    commit('USERNAME', guest.username)
    let res = await dispatch('createGuestAccount', [guest.username, guest.locationId])
    if(res?.success) { //try again
      dispatch('api/auth/signinGuestCallback', null, {root: true})
      return
    } else { //go to reset space/room lobby + clear existing guest
      let redirectUrl = parseLocalStorage('ssoGuestRedirect')
      if(redirectUrl?.path) dispatch('routing/change', redirectUrl.path, { root: true })
      else dispatch('routing/goToHome', null, {root:true})
      localStorage.removeItem('ssoRedirect')
      localStorage.removeItem('guestUser')
    }

    return res
  },
  async handleCreateGuestLogin({getters, dispatch}, locationId) {
    //create login + silent login first
    let res = await dispatch('api/nav/createGuestLogin', [getters.username, locationId], {root: true})

    let data = res?.success
    if(data) dispatch('guest/room/updateData', data, {root: true})
    else dispatch('popups/guest/errorEnteringGuestLobby', null, {root: true})

    return res
  },
  async registerAsGuestHandler({getters, dispatch}, comp = 'body') {
    if(typeof comp !== 'string') comp = 'body'
    if(!getters.guestStorageData) await dispatch('handleCheckForGuestInStorage')
    let guestId = getters.guestStorageData?.userId
    let token = getters.guestStorageData?.oneTimeSignInToken
    if(guestId && token) {
      let returnUrl = `${location.pathname}`
      let returnData = {
        path: returnUrl,
        timestamp: Date.now()
      }
      localStorage.setItem('ssoRedirect', JSON.stringify(returnData))
      dispatch('api/auth/registerAsGuest', [guestId, token, comp], {root: true})
    } else dispatch('routing/goToRegister', null, {root: true})
  },

  async handleCheckForGuestInStorage({rootGetters, commit}) {
    let guest = localStorage.getItem('guestUser')
    if(guest) guest = JSON.parse(guest)
    if(rootGetters['api/auth/authenticated']) {
      //save if current guest login on load (from different tab maybe with no local storage)
      let user = rootGetters['current_user/data']
      let guestData = {
        userId: user.id,
        username: user.firstName
      }
      if(!!guest && guest?.userId === user.id) guestData = {...guestData, ...guest}

      if(rootGetters['current_user/isExternalGuest'] && guestData.username && guestData.userId) commit('GUEST_STORAGE_DATA', guestData)
      return
    }

    if(guest) {
      commit('GUEST_STORAGE_DATA', guest)
    } else commit('GUEST_STORAGE_DATA', null)
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
